/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.27
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function MoveFromJSON(json) {
    return MoveFromJSONTyped(json, false);
}
export function MoveFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'moveID': !exists(json, 'moveID') ? undefined : json['moveID'],
        'assetID': !exists(json, 'assetID') ? undefined : json['assetID'],
        'moveDateTime': !exists(json, 'moveDateTime') ? undefined : (json['moveDateTime'] === null ? null : new Date(json['moveDateTime'])),
        'moveTimestampLTZ': !exists(json, 'moveTimestampLTZ') ? undefined : (json['moveTimestampLTZ'] === null ? null : new Date(json['moveTimestampLTZ'])),
        'fromLocation': !exists(json, 'fromLocation') ? undefined : json['fromLocation'],
        'toLocation': !exists(json, 'toLocation') ? undefined : json['toLocation'],
        'receivingDept': !exists(json, 'receivingDept') ? undefined : json['receivingDept'],
        'receivingPerson': !exists(json, 'receivingPerson') ? undefined : json['receivingPerson'],
        'receivingPersonID': !exists(json, 'receivingPersonID') ? undefined : json['receivingPersonID'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}
export function MoveToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'moveID': value.moveID,
        'assetID': value.assetID,
        'moveDateTime': value.moveDateTime === undefined ? undefined : (value.moveDateTime === null ? null : value.moveDateTime.toISOString()),
        'moveTimestampLTZ': value.moveTimestampLTZ === undefined ? undefined : (value.moveTimestampLTZ === null ? null : value.moveTimestampLTZ.toISOString()),
        'fromLocation': value.fromLocation,
        'toLocation': value.toLocation,
        'receivingDept': value.receivingDept,
        'receivingPerson': value.receivingPerson,
        'receivingPersonID': value.receivingPersonID,
        'reason': value.reason,
        'status': value.status,
    };
}
